import { createApp, nextTick } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import * as navbar from "@/services/navbar.service"

window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle.js');

import "bootstrap-icons/font/bootstrap-icons.css"

import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

import { logout } from '@/services/oidc.service';

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.interceptors.request.use(
    config => {
        if (localStorage.getItem('token') != null) {
            config.headers.authorization = `Bearer ${localStorage.getItem('token')}`;
        }
        return config;
    }, error => {
        return Promise.reject(error);
    });

axios.interceptors.response.use(response => {
    return response;
}, error => {
    // Go back to login page when not authenticated
    if (error.response.status === 401) {
        localStorage.clear();
        logout();
    }
    else if (error.response.status === 403) {
        emitter.emit("showLoader", false);
        alert("You don`t have permission to perform this action.");
    }
    return Promise.reject(error);
});

router.afterEach(async (to) => {
    await nextTick();
    navbar.init(to.path);
});

const app = createApp(App);

// Use Vuex store and router
app.use(store);
app.use(router);

// Mount the app
app.mount('#app');
